import { Counter } from "../../../src/components/Counter";
import React from 'react';
import { MDXTag } from '@mdx-js/tag';
export default {
  Counter,
  React,
  MDXTag
};